import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from "react";
import { useIsFirstRender } from "usehooks-ts";
import { VolumeOffFilledIcon, VolumeUpFilledIcon } from "@parkschannel/ui";
const INITIAL_VALUES = {
    isMute: true,
    volume: 90
};
export const VolumeControl = (param)=>{
    let { defaultValues , onMute , onVolumeChange  } = param;
    const isFirstRender = useIsFirstRender();
    const [isMute, setIsMute] = useState((defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.isMute) || INITIAL_VALUES.isMute);
    const [volume, setVolume] = useState((defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.volume) || INITIAL_VALUES.volume);
    const toggleMute = useCallback(()=>{
        setIsMute((prev)=>!prev);
    }, [
        isMute
    ]);
    const changeVolume = useCallback((e)=>{
        setVolume(e.target.valueAsNumber);
    }, [
        volume
    ]);
    useEffect(()=>{
        if (isFirstRender) return;
        onMute === null || onMute === void 0 ? void 0 : onMute(isMute);
        if (isMute) {
            setVolume(0);
        }
    }, [
        isMute
    ]);
    useEffect(()=>{
        if (isFirstRender) return;
        onVolumeChange === null || onVolumeChange === void 0 ? void 0 : onVolumeChange(volume);
        if (volume !== 0) {
            setIsMute(false);
        } else {
            setIsMute(true);
        }
    }, [
        volume
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative group flex items-center gap-2",
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: toggleMute,
                children: isMute ? /*#__PURE__*/ _jsx(VolumeOffFilledIcon, {
                    className: "text-neutral-100"
                }) : /*#__PURE__*/ _jsx(VolumeUpFilledIcon, {
                    className: "text-neutral-100"
                })
            }),
            /*#__PURE__*/ _jsx("input", {
                type: "range",
                min: 0,
                max: 100,
                value: volume,
                onChange: changeVolume,
                className: "w-[100px] h-1.5 bg-neutral-100 rounded-none appearance-none cursor-pointer dark:bg-neutral-100"
            })
        ]
    });
};
